import { useMutation } from "@tanstack/react-query";
import { CompanyDTO } from "api/model/company/CompanyDTO";
import { errorToaster, successToaster } from "components/pages/measurement-devices/utils/utils";
import { useUserState } from "store/user-store";
import { CompanyApi } from "../CompanyApi";
import { defaultResponseHandler, IQueryOptions, QueryKey, useQueryWrapper } from "./api-hooks-common";

export const useGetCompanies = (options?: IQueryOptions) =>
  useQueryWrapper([QueryKey.COMPANIES], () => CompanyApi.getCompanies(), null, options);

export const useUpdateCompany = () => {
  const setCompanyContext = useUserState(state => state.setCompanyContext);
  return useMutation({
    mutationFn: async (company: CompanyDTO) => {
      const res = await CompanyApi.updateCompany(company);
      return defaultResponseHandler(res);
    },
    onSuccess: data => {
      successToaster("Company updated successfully");
      if (data) setCompanyContext(data);
    },
    onError: error => {
      errorToaster(`Failed to update company: ${error.message}`);
    },
  });
};
